/** Submenu keys must match Sigma resolver secrets (Secrets Manager). */
export const QBR_REPORTS = [
  {
    id: 'executive',
    label: 'Executive QBR',
    submenu: 'qbr-executive',
  },
  {
    id: 'market-performance',
    label: 'Market QBR',
    submenu: 'qbr-market-performance',
  },
  {
    id: 'product-assortment',
    label: 'Product QBR',
    submenu: 'qbr-product-assortment',
  },
];
